<template>
  <div class="nav">
    <div class="nav_main">
      <div class="assortment">
        <div class="assortment_top" @mouseleave="hiddenOneCategory()" @mouseenter="showCategoryOne()"
             @click="searchList({categoryCode:''})">全部物料分类
        </div>
        <div class="assortment_bottom" @mouseleave="hiddenCategory()" v-show="categoryOne" @mouseenter="showCategory()">
          <ul>
            <li v-for="ca in categoryList" @click="searchList(ca)">
              {{ ca.categoryName }}
            </li>
          </ul>
        </div>
      </div>
      <div class="nav_list">
        <template v-for="(item,index) in navList"
                  v-if="!item.type ||(item.type && shopInfo.shopType===1)">
          <el-dropdown v-if="item.children">
          <span class="el-dropdown-link" :class="navIndex==index?'nav_select':''" @click="toPath(item.path)">
            {{ item.route }}
            <i class="el-icon-arrow-down" v-show="item.children"></i>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="toPath(itemm.path)" v-for="(itemm,indexx) in item.children">{{
                  itemm.route
                }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-else class="el-dropdown-link" :class="navIndex==index?'nav_select':''" @click="toPath(item.path)"
               v-text="item.route">
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {categoryRootList} from '../../api'
import {getToken} from '@/utils/auth'

export default {
  name: 'navBar',
  computed: {
    shopInfo () {
      return this.$store.state.shopInfo
    },
  },
  data () {
    return {
      getToken: getToken(),
      address:'',
      categoryOne: false,
      categoryTwo: false,
      isHidden: null,
      categoryList: [],
      categoryTwoData: [],
      navIndex: 0,
      navList: [
        {
          route: '首页',
          path: '/'
        },
        {
          route: '物料目录',
          path: '/goodsList'
        },
        {
          route: '备货单',
          path: '/shopCar'
        },
        {
          route: '订单管理',
          path: '/userCenterOrder',
          children: [
            {
              route: '我的订单',
              path: '/userCenterOrder?type=myOrder',
            },
            {
              route: '收货单',
              path: '/userCenterOrder?type=receivingOrder',
            },
            // {
            //   route: '退货单',
            //   path: '/userCenterOrder?type=salesReturnOrder',
            // },
            {
              route: '费用单',
              path: '/userCenterOrder?type=feeOrder',
            },
            {
              route: '预算数据单',
              path: '/userCenterOrder?type=restockOrder'
            },
            {
              route: '汇总支付订单',
              path: '/userCenterOrder?type=myMainOrder',
            },
            {
              route: '门店对账',
              path: '/userCenterOrder?type=storeReconciliation'
            }
          ]
        },
        {
          route: '退货报损',
          path: '/shopReturn'
        },
        {
          route: '库存盘点',
          path: '/shopCheck',
          type: 1
        },
        {
          route: '自制采购',
          path: '/shopPurchase',
          type: 1
        },
        {
          route: '门店调拨',
          path: '/shopAllot',
          type: 1,
          children: [
            {
              route: '调出',
              path: '/shopAllot?type=myOrder',
              type: 1
            },
            {
              route: '调入',
              path: '/shopAllot?type=toMyOrder',
              type: 1
            },
          ]
        },
        {
          route: '报表查询',
          path: '/shopGoodsStock',
          type: 1,
          children: [
            {
              route: '物料库存',
              path: '/shopGoodsStock?type=kuCun',
              type: 1
            },
            {
              route: '收发存汇总表',
              path: '/shopGoodsStock?type=shouFaCun',
              type: 1
            },
          ]
        }
        // {
        //   route: '资金账户',
        //   path: ''
        // },
        // {
        //   route: '数据统计',
        //   path: ''
        // },
      ],
    }
  },
  methods: {
    toPath (path) {
      console.log(path)
      this.$router.push(path)
      if(path=='/userCenterOrder?type=storeReconciliation'){
        window.open(`${this.address}/jdl/DzCustomerList?token=${this.getToken}&shopName=${this.shopInfo.shopName}&shopType=${this.shopInfo.shopType}&shopId=${this.shopInfo.id}`, '_blank');
      }
    },
    searchList (categoryData) {
      this.$router.push({
        name: 'goodsList', query: {
          t: Date.now(),
          categoryCode: categoryData.categoryCode
        }
      })
    },
    //展示一级分类
    hiddenOneCategory () {
      this.isHidden = setTimeout(() => {
        this.categoryOne = false
      }, 500)
    },
    showAllCategory (data) {
      if (data) {
        this.categoryTwoData = data
      }
      if (this.isHidden) {
        clearTimeout(this.isHidden)
        this.categoryOne = true
      }
      this.categoryTwo = true
    },
    hiddenCategory () {
      this.isHidden = setTimeout(() => {
        this.categoryOne = false
        this.categoryTwo = false
      }, 500)
    },
    showCategory () {
      if (this.isHidden) {
        clearTimeout(this.isHidden)
      }
    },
    showCategoryOne () {
      this.categoryTwo = false
      if (this.isHidden) {
        clearTimeout(this.isHidden)
        this.categoryOne = true
      }
      this.categoryOne = true
    }
  },
  created () {
    categoryRootList().then(response => {
      this.categoryList = response.result
    })
  },
  mounted () {
    for (let i = 0; i < this.navList.length; i++) {
      if (this.$route.path === this.navList[i].path) {
        this.navIndex = i
      }
    }
    if (process.env.NODE_ENV === 'development') {
      this.address='http://192.168.10.10:3000'
    } else {
      if (window.location.href.search('test') !== -1) {
        this.address = 'http://testboot.jiedilia.com:3000'
      } else {
        this.address = 'https://s.sisbro.cn'//需更换生产地址
      }
    }
  }

}
</script>

<style scoped>
@import "../../assets/style/index.css";
.assortment_bottom {
  display: block;
}

.nav > li {

}
</style>



// WEBPACK FOOTER //
// src/components/nav/navBar.vue